module.exports = __webpack_public_path__ + "static/img/best_game.72c805a6.png";